import { CheckboxTheme as CheckboxDefaultTheme } from "@acin.reactjs/acin-ui/checkbox";
import { ComponentCSSStyle } from "@acin.reactjs/acin-ui/theme";
import { DefaultTheme } from "styled-components";

const checkboxTheme = (
  theme: DefaultTheme,
): ComponentCSSStyle<CheckboxDefaultTheme> => ({
  input: {
    justifySelf: "center",
  },
  variants: {
    public: {
      inputChecked: {
        backgroundColor: theme.palette.secondary[500],
        "& [fill]:not([stroke='fill'])": {
          fill: `${theme.palette.common.black} !important`,
        },
        border: "1px solid transparent",
      },
      hover: {
        inputChecked: {
          backgroundColor: theme.palette.secondary[500],
          border: "1px solid transparent",
        },
      },
      focused: {
        input: {
          boxShadow: `0px 0px 0px 2px${theme.palette.secondary[100]}`,
        },
        inputChecked: {
          boxShadow: "none",
        },
      },

      error: {
        input: {
          "& + div div": {
            display: "none",
          },
        },
      },
    },
    parent: {
      formLabel: {
        label: {
          fontWeight: theme.typography.fontWeights.medium,
        },
      },
    },
  },
  inputWithLabel: {
    alignSelf: "center",
    placeSelf: "start",
  },
  formLabel: { asterisk: { readOnly: { root: { display: "none" } } } },
});

export default checkboxTheme;
